import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/LaundryFields.json";
import { GetAll } from "adminApi/LaundryApi/Laundry.js";

const LaundryTaskListTable = () => {
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];
    const { tabledata } = fields;

    // Fetch Hook
    const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
        page,
        limit,
        search: debouncedSearch,
        title: "Laundry Task List",
    });

    const displayFields = generateDisplayFields(tabledata);

    // Table Hook — pass raw data so IsEditDisble key comparison works on raw values
    // Edit is disabled when receive_status = 'received' (laundry already received back)
    const { formattedData, columns } = useTableConfig({
        data,
        page,
        limit,
        canShowAction,
        refetch,
        IsDelete: false,
        isView: true,
        IsEditDisble: true,
        IsEditDisbleKey: "receive_status",
        IsEditDisbleValue: "received",
        config: {
            entityName: "Laundry Task",
            editUrl: "edit-laundry",
            idKey: "laundry_id",
            deleteApi: () => { },
            displayFields,
            ViewUrl: "view-laundry",
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const onPageChange = (p) => setPage(p);
    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
                fileName: "Laundry Assign",
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch: handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange,
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange,
            }}
        />
    );
};

export default LaundryTaskListTable;
